var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.month > 0)?_c('span',[_vm._v(_vm._s(_vm.month))]):_c('span',[_c('i',{staticClass:"fas fa-question-circle text-warning"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }